module.exports = __webpack_public_path__ + "static/media/cattle-drones-2-for-one-up.21269933.jpg";